import { render, staticRenderFns } from "./pending-workloads.vue?vue&type=template&id=7ffba86c&scoped=true&"
import script from "./pending-workloads.vue?vue&type=script&lang=js&"
export * from "./pending-workloads.vue?vue&type=script&lang=js&"
import style0 from "./pending-workloads.vue?vue&type=style&index=0&id=7ffba86c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffba86c",
  null
  
)

export default component.exports